import OpenTestAssignments from "./OpenTestAssignments";
import ClosedTestAssignments from "./ClosedTestAssignments";
import React, {useContext, useEffect, useState} from "react";
import Tab from "../../../common/Tab";
import {Assignment, Rule} from "@mui/icons-material";
import {BrandContext} from "../../../common/BrandContext";
import Tabs from "../../../common/Tabs";
import Card, {CARD} from "../../../common/Card";
import "../../../../webapp/users/dashboard/js/test.js";
import TestResult from "./TestResult";

const TABS = {
    OPEN:{tabVal:0, description: 'Assigned',hash:'assigned'},
    CLOSED:{tabVal:1, description: 'Results',hash:'results'}
    };

export const getSittingsText = (record, assessmentTestName, revisionTestName)=>{
    if(!record.autoMark){
        return 'PDF';
    }else if(record.revision){
        if(record.diagnosticTest && !record.adaptive){
            return 'Multiple sittings';
        }else{
            return revisionTestName;
        }
    }else{
        if(record.diagnosticTest && !record.adaptive){
            return 'One sitting';
        }else{
            return assessmentTestName;
        }
    }
}


const StudentTestAssignments = ()=>{
    const brandConfig = useContext(BrandContext);
    const [testResultId, setTestResultId] = useState();
    const [visibleSection, setVisibleSection] = useState('TEST_RESULTS');

    const handleViewTestResult = (record)=>{
        if(record.testResultId == undefined) {
            return;
        }
        setTestResultId(record.testResultId);
        setVisibleSection('TEST_RESULT');
    }

    const handleCloseTestResult = () => {
        setTestResultId(undefined);
        setVisibleSection('TEST_RESULTS');
    };

    const openTitle = 'Assigned '+brandConfig.testsName.toLowerCase(),
        closedTitle = brandConfig.testName+ ' results';

    if(brandConfig.showStudentAssessmentTabbed){
        return (<Card>
            <div className={visibleSection != 'TEST_RESULTS' ? ' ch-hide' : ''}>
                <Tabs id={'studentTestAssignments'} variant="standard">
                    <Tab id={'studentTestAssignmentsOpen'} hash={TABS.OPEN.hash} key={TABS.OPEN.tabVal}
                         value={TABS.OPEN.tabVal} tab={<>
                        <Assignment className={'margin-r--m'}/>
                        <span className={'margin-r--m tabText'}>{TABS.OPEN.description}</span></>}
                         children={<OpenTestAssignments/>}/>
                    <Tab id={'studentTestAssignmentsClosed'} hash={TABS.CLOSED.hash} key={TABS.CLOSED.tabVal}
                         value={TABS.CLOSED.tabVal} tab={<>
                        <Rule className={'margin-r--m'}/>
                        <span className={'margin-r--m tabText'}>{TABS.CLOSED.description}</span></>}
                         children={<ClosedTestAssignments handleViewTestResult={handleViewTestResult}/>}/>
                </Tabs>
            </div>
            {testResultId != undefined  && visibleSection == 'TEST_RESULT' &&
                <TestResult testResultId={testResultId} handleBack={handleCloseTestResult}/>
            }
        </Card>)
    }

    return (
        <>
            <div className={'flexColumn mediumGap' + (visibleSection != 'TEST_RESULTS' ? ' ch-hide' : '')}>
                <Card padding={CARD.PADDING.EXTRA_SMALL}>
                    <OpenTestAssignments title={openTitle} defaultTablePageSize={5}/>
                </Card>
                <Card padding={CARD.PADDING.EXTRA_SMALL}>
                    <ClosedTestAssignments title={closedTitle} defaultTablePageSize={5} handleViewTestResult={handleViewTestResult}/>
                </Card>
            </div>
            {testResultId != undefined  && visibleSection == 'TEST_RESULT' &&
                <TestResult testResultId={testResultId} handleBack={handleCloseTestResult}/>
            }
        </>
    )

}
export default StudentTestAssignments;
